import { useTranslation } from "react-i18next";
import { Button, Icon } from "semantic-ui-react";

import CarRepair from "assets/img/car-repair.png";
import { Logo } from "components";
import { useRedirectToLandingPage } from "modules/Login/hooks";
import LicenseIcon from "router/components/NotFoundPage/404-license-plate.svg";
import "router/components/NotFoundPage/NotFoundPage.scss";

export const NotFoundPage = () => {
  const { t } = useTranslation();
  const redirectToLandingPage = useRedirectToLandingPage();

  return (
    <div className="NotFoundPage">
      <div className="NotFoundPage-overlay">
        <div className="NotFoundPage-container">
          <div className="NotFoundPage-logo">
            <Logo />
          </div>
          <div className="NotFoundPage-action-buttons">
            <Button icon labelPosition="left" onClick={() => redirectToLandingPage}>
              <Icon className="arrow left" />
              {t("v8_back_to_homepage", "Back to Homepage")}
            </Button>
          </div>
          <div className="NotFoundPage-car-repair">
            <img src={CarRepair} />
            <div className="NotFoundPage-svg-icon">
              <img src={LicenseIcon} alt="license-plate-404" />
            </div>
            <div className="NotFoundPage-error-text">{t("v8_page_not_found", "Page Not Found")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
